import configure from 'redux-idle-monitor';
import { IDLE_STATUSES } from './constants';
import {
  idleStatusDelay,
  activeStatusAction,
  idleStatusAction,
} from './actions';

// These are the default events that will trigger user active status but can be customized if provided.
const activeEvents = [
  'keydown',
  'mousedown',
  'touchstart',
  'touchmove',
  'MSPointerDown',
];

const opts = {
  appName: 'ct',
  IDLE_STATUSES,
  idleStatusDelay,
  activeStatusAction,
  idleStatusAction,
  activeEvents,
};

const { middleware, reducer, actions } = configure(opts);
export { middleware, reducer, actions };



// WEBPACK FOOTER //
// ./src/store/redux-idle-monitor/index.js